import { render, staticRenderFns } from "./VersionsDialogBox.vue?vue&type=template&id=74373db6&scoped=true&"
import script from "./VersionsDialogBox.vue?vue&type=script&lang=js&"
export * from "./VersionsDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74373db6",
  null
  
)

export default component.exports